import React from "react";
import ComponentWrapper from "../Shared/ComponentWrapper";

const TrustedBy = () => {
  return (
    <ComponentWrapper styles="pt-[6rem] sm:pt-[7rem]">
      <div className="w-full flex justify-center items-center flex-col gap-3">
        <h2 className="text-[40px] leading-[48px] text-center text-black font-medium">
          Secure. Non-custodial. Trusted.
        </h2>
        <p className="text-[18px] max-w-[620px] text-center text-gray-1 font-normal">
          You keep full custody of your wallet at all times. Helix AI uses session-based signing to execute actions on your behalf — your keys, your assets, your control.
        </p>
      </div>
    </ComponentWrapper>
  );
};

export default TrustedBy;
